import { ArrowRightIcon } from 'lucide-react'

import { Button, usePageTitle } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { CenteredLayout } from '../employer_onboarding/CenteredLayout'

export function AlreadyCompletedPage () {
  usePageTitle('This form has already been completed')

  const { assign } = useWindowLocation()

  const handleBackToDashboard = () => {
    assign('/employers/employees')
  }

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='This form has already been completed'
        subheading='If you need help adding additional owners or have additional questions, please reach out to support@thatch.com'
        align='center'
      />
      <CenteredLayout.Buttons align='center'>
        <Button
          variant='primary'
          onClick={handleBackToDashboard}
          rightIcon={ArrowRightIcon}
        >
          Back to dashboard
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
